/* global $ */

import React, { Component } from 'react';
import { Button, Form, Dropdown } from 'semantic-ui-react';

export class SettingsState extends Component {

    componentDidMount() {
        $(this.refs.freeTime).val(this.props.fieldValues.subscriptionTime);
        this.validateForm();
    }

    componentDidUpdate() {
        this.validateForm();
    }

    setFreeTime(e, data) {
        $(this.refs.freeTime).val(data.value);
    }

    submitSettingsStateForm() {
        $('#settingsStateSubmit').click();
    }

    validateForm() {
        $('.ui.accordion')
            .accordion()
        ;

        var self = this;
        $('#settingsForm')
            .form({
                fields: {
                    freeTimeValue: {
                        rules: [
                            {
                                type   : 'empty',
                                prompt : this.props.showMessage('message_6_15')
                            }
                        ]
                    },
                    facebookLink: {
                        optional: true,
                        rules: [
                            {
                                type: 'url',
                                prompt : this.props.showMessage('message_6_16')
                            }
                        ]
                    },
                    twitterLink: {
                        optional: true,
                        rules: [
                            {
                                type: 'url',
                                prompt : this.props.showMessage('message_6_17')
                            }
                        ]
                    },
                    foursquareLink: {
                        optional: true,
                        rules: [
                            {
                                type: 'url',
                                prompt : this.props.showMessage('message_6_18')
                            }
                        ]
                    }
                },
                onSuccess: function () {
                    self.nextStep()
                },
                onFailure: function (e) {
                    if ($('#freeTimeValueContainer').hasClass('error')) {
                        $('#freeTime').addClass('error')
                    }
                }
            })
        ;
    };

    render() {
        var stateOptions = [
            { value: 'PT15M', text: this.props.showMessage('message_6_06') },
            { value: 'PT30M', text: this.props.showMessage('message_6_07') },
            { value: 'PT1H', text: this.props.showMessage('message_6_08') },
            { value: 'PT2H', text: this.props.showMessage('message_6_09') },
            { value: 'PT4H', text: this.props.showMessage('message_6_10') } ];
        return (
            <div className="outerContent">
                <div className="innerContent">
                    <h2 className="purple title">{this.props.showMessage('message_6_01')}</h2>
                    <div className="ui fluid styled accordion">
                        <Form id="settingsForm">
                        <div className="title">
                            {this.props.showMessage('message_6_02')}
                            <i className="icon-arrow"></i>
                        </div>
                        <div className="content">
                            <p>{this.props.showMessage('message_6_03')}</p>
                            <Form.Field id="freeTimeValueContainer">
                                <input type="hidden" ref="freeTime" name="freeTimeValue" />
                            </Form.Field>
                            <Form.Field id="freeTime">
                                <Dropdown defaultValue={this.props.fieldValues.subscriptionTime}
                                          className="ui compact selection dropdown"
                                          onChange={this.setFreeTime.bind(this)}
                                          placeholder={this.props.showMessage('message_6_04')}
                                          options={stateOptions}
                                />
                            </Form.Field>
                        </div>
                        <div className="title">
                            {this.props.showMessage('message_6_11')}
                            <i className="icon-arrow"></i>
                        </div>
                        <div className="content">
                            <div className="socialFields flexbox">
                                <Form.Field>
                                    <i className="icon-facebook-circle" style={{color: '#3B5998'}}></i>
                                    <input type="text" name="facebookLink" placeholder="Facebook" ref="facebookLink" defaultValue={this.props.fieldValues.facebookLink} />
                                </Form.Field>
                                <Form.Field>
                                    <i className="icon-twitter-circle" style={{color: '#55ACEE'}}></i>
                                    <input type="text" name="twitterLink" placeholder="Twitter" ref="twitterLink" defaultValue={this.props.fieldValues.twitterLink} />
                                </Form.Field>
                                <Form.Field className="last">
                                    <i className="icon-foursquare-circle" style={{color: '#F94877'}}></i>
                                    <input type="text" name="foursquareLink" placeholder="Foursquare" ref="foursquareLink" defaultValue={this.props.fieldValues.foursquareLink} />
                                </Form.Field>
                            </div>
                        </div>

                            <div className="hidden">
                                <Button id="settingsStateSubmit"></Button>
                            </div>

                            <div className="ui error message"></div>
                        </Form>
                    </div>
                </div>
                <div className="footer">
                    <div className="formButtons">
                        <Button className="secondary" onClick={this.previousStep.bind(this)}>{this.props.showMessage('message_6_13')}</Button>
                        <Button className="primary" onClick={this.submitSettingsStateForm}>{this.props.showMessage('message_6_14')} ></Button>
                    </div>
                </div>
            </div>
        )
    };

    previousStep() {
        if (this.refs.freeTime != null && this.refs.facebookLink != null && this.refs.twitterLink != null && this.refs.foursquareLink != null) {

            // Get values via this.refs
            var data = {
                subscriptionTime: this.refs.freeTime.value,
                facebookLink: this.refs.facebookLink.value,
                twitterLink: this.refs.twitterLink.value,
                foursquareLink: this.refs.foursquareLink.value
            };

            this.props.saveValues(data);
            this.props.previousStep();
        }
    }

    nextStep() {

        if (this.refs.freeTime != null && this.refs.facebookLink != null && this.refs.twitterLink != null && this.refs.foursquareLink != null) {

            // Get values via this.refs
            var data = {
                subscriptionTime: this.refs.freeTime.value,
                facebookLink: this.refs.facebookLink.value,
                twitterLink: this.refs.twitterLink.value,
                foursquareLink: this.refs.foursquareLink.value
            };

            this.props.saveValues(data);
            this.props.nextStep();
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/SettingsState.jsx